
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Modals.css';
import { Title } from '../title';
import { ClickElement } from '../form';
import { ModalsWrapper } from './';
import * as ReactGA from 'react-ga';
import {
  changeAdsShowBlockerConsentPersistent,
  selectAdsShowBlockerConsent,
} from '../../ducks';

export const AdsBlockerModal = () => {
  const adsShowBlockerConsent = useSelector(selectAdsShowBlockerConsent);
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.classList.add('noscroll');
    return () => document.body.classList.remove('noscroll');
  }, []);

  return(
    <ModalsWrapper>
      <Title Tag='h1'>
        Hoi Adblockert!
      </Title>
      <p className='paragraph'>
        {/* eslint-disable-next-line max-len */}
        <strong>We begrijpen het:</strong> teveel reclame is bloedje irritant en daar kom je hier niet voor. En gratis Dumpert kijken is leuk, alleen kunnen wij het niet gratis maken. Servers en personeel kosten veel geld en daarom plaatsen we advertenties. Dus zou je voor ons alsje alsjeblieft een uitzondering willen maken? <a 
          href='https://fundingchoicesmessages.google.com/s/whitelist' 
          rel='noopener noreferrer' 
          target='_blank'
          style={{ 'color': 'var(--color-brand)'}}>
              Zo werkt het
        </a>. Xx
      </p>
      <div className={styles['button-bar']}>
        <ClickElement
          tertiary
          ElementType='button'
          text='Nee, dank je'
          onClick={() => {
            dispatch(changeAdsShowBlockerConsentPersistent(!adsShowBlockerConsent));
            ReactGA.event({
              category: 'Other',
              action: 'rejected',
              label: 'AdBlockerCheck',
            });
          }}
        />
        <ClickElement
          primary
          ElementType='button'
          text='Ja, ik zal jullie accepteren'
          onClick={() => {
            dispatch(changeAdsShowBlockerConsentPersistent(!adsShowBlockerConsent));
            ReactGA.event({
              category: 'Other',
              action: 'accepted',
              label: 'AdBlockerCheck',
            });
          }}
        />
      </div>
    </ModalsWrapper>
  ) ; 
};